const WEIGHT_UNITS = new Set(['lb', '0.5lb', 'oz', 'g', 'kg']);

export function isWeightBasedUnit(unit) {
    if (!unit) return false;
    const normalized = String(unit).toLowerCase().trim();
    if (normalized.includes('fl')) return false;
    return (
        WEIGHT_UNITS.has(normalized) ||
        /(?:\d*\.?\d+)?lb$/.test(normalized) ||
        normalized.endsWith('oz')
    );
}

export function getItemLabel(unitCount) {
    const count = Number(unitCount);
    return count === 1 ? 'item' : 'items';
}

export function formatItemsPerUnit(unitCount, unit) {
    const count = Number(unitCount);
    if (!Number.isFinite(count) || count < 1 || !unit) return null;
    return `${count} ${getItemLabel(count)} per ${unit}`;
}
